export default function LinkIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.60556 4.02254L8.99768 2.63042C9.28492 2.34292 9.62598 2.11483 10.0014 1.95918C10.3768 1.80353 10.7792 1.72336 11.1856 1.72327C11.592 1.72317 11.9944 1.80315 12.3699 1.95863C12.7454 2.1141 13.0866 2.34204 13.3739 2.6294C13.6613 2.91677 13.8892 3.25794 14.0447 3.63342C14.2002 4.0089 14.2802 4.41134 14.2801 4.81774C14.28 5.22414 14.1998 5.62653 14.0442 6.00194C13.8885 6.37735 13.6604 6.71841 13.3729 7.00565L11.3842 8.99439C11.0969 9.28167 10.7558 9.50955 10.3805 9.66503C10.0051 9.8205 9.60283 9.90052 9.19655 9.90052C8.79028 9.90052 8.38798 9.8205 8.01263 9.66503C7.63728 9.50955 7.29622 9.28167 7.00894 8.99439M8.40106 11.9775L7.00894 13.3696C6.72171 13.6571 6.38065 13.8852 6.00524 14.0409C5.62983 14.1965 5.22743 14.2767 4.82103 14.2768C4.41463 14.2769 4.0122 14.1969 3.63672 14.0414C3.26124 13.8859 2.92007 13.658 2.6327 13.3706C2.34533 13.0833 2.1174 12.7421 1.96192 12.3666C1.80644 11.9911 1.72647 11.5887 1.72656 11.1823C1.72666 10.7759 1.80682 10.3735 1.96247 9.99809C2.11813 9.62268 2.34622 9.28162 2.63372 8.99439L4.62246 7.00565C4.90974 6.71837 5.25079 6.49048 5.62614 6.33501C6.00149 6.17953 6.40379 6.09951 6.81007 6.09951C7.21635 6.09951 7.61864 6.17953 7.994 6.33501C8.36935 6.49048 8.7104 6.71837 8.99768 7.00565"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
